// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__1RN1o","list_wrapper":"list_wrapper__3vlcI","legendOuterWrapper":"legendOuterWrapper__1plS1","legendInnerWrapper":"legendInnerWrapper__3UVO2","contributionWrapper":"contributionWrapper__e3h4G","wrapperItem":"wrapperItem__1qpos","DonorContribution":"DonorContribution__2H19o","allDonorContribution":"allDonorContribution__2439N","contributionText":"contributionText__1DRo2"};


//////////////////
// WEBPACK FOOTER
// ./components/donutBarChart/components/groupedBarChart/style.scss
// module id = qY+b
// module chunks = 22